<script lang="ts">
  import EmployerPayoutsComponent from '../../components/charity/employer/EmployerPayouts.svelte';
  
  export let params: { id: string };
</script>

<EmployerPayoutsComponent employerId={params.id} />

